import {
  addStringMap,
  toSupportedLocale,
  type StringProvider,
} from "@1js/localization";
import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  getClientSettings,
  getCopilotPortalSettings,
  getPageHostName,
  getPromptsClientSettings,
  removeLDashArray,
} from "../../utils/utils.web";
import { emptyProvider } from "../PageWrapper.web";
import { CapabilitiesShadowContainer } from "./CapabilitiesShadowContainer.web";

const settings = getPromptsClientSettings();
const copilotProductLinks = settings.copilotProductUrls;
const capabilitiesLink = getCopilotPortalSettings().capabilitiesSiteUrl;
const clientSettings = getClientSettings();
const whatsNewLink = getCopilotPortalSettings().whatsNewUrl;
const gettingStartedLinks = settings.gettingStartedUrls;
const hostname = getPageHostName();
const flightSet = new Set(clientSettings.flights);
const locale = toSupportedLocale(clientSettings.locale);

const renderApp = (provider: StringProvider, mountPoint: HTMLElement) => {
  ReactDOM.render(
    <CapabilitiesShadowContainer
      locale={locale}
      header={{
        capabilitiesLink: capabilitiesLink,
        copilotProductLinks: removeLDashArray(copilotProductLinks),
        whatsNewLink: whatsNewLink,
        gettingStartedLinks: removeLDashArray(gettingStartedLinks),
      }}
      setting={{
        user: clientSettings.user,
        licenses: settings.licenses,
        activeFlights: flightSet,
      }}
      serviceHost={hostname}
      provider={provider}
    ></CapabilitiesShadowContainer>,
    mountPoint
  );
};

class MyWebComponent extends HTMLElement {
  connectedCallback() {
    const style = document.createElement("style");
    // This is done to prevent the web component from inheriting styles from the parent page
    style.innerText = ":host {all: initial;}";
    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.append(style);
    const mountPoint = document.createElement("div");
    shadowRoot.appendChild(mountPoint);

    const flightSet = new Set(clientSettings.flights);
    flightSet.delete("isHeaderEnabled");
    flightSet.add("isBookmarksEnabled");
    flightSet.add("is3SServiceEnabled");

    window.loadStrings
      ? window.loadStrings(locale).then((strings) => {
          const provider = addStringMap(locale, strings, emptyProvider);
          renderApp(provider, mountPoint);
        })
      : renderApp(emptyProvider, mountPoint);
  }
}

customElements.define("prompts-grid", MyWebComponent);

// Create the web component
const promptsGridComponent = document.createElement("prompts-grid");

// Find the section with id 'prompts-grid'
const section = document.getElementById("prompts-grid");

// Add the web component to the section
if (section) {
  section.appendChild(promptsGridComponent);
}
